import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FormContext } from "../../../common/context/context";
import { LangHelper } from '../lang/helper';
import { InputRadioWrapper, InputRadioLabel, InputRadioTitle, InputRadioText } from './radio.styles';
export default function InputRadio(props) {
    var name = props.name, value = props.value, title = props.title, text = props.text, onChange = props.onChange, checked = props.checked;
    var state = React.useContext(FormContext).state;
    var _a = React.useState(title), titleValue = _a[0], setTitleValue = _a[1];
    var _b = React.useState(text), textValue = _b[0], setTextValue = _b[1];
    useEffect(function () {
        if (title) {
            var translatedTitleValue = LangHelper.getLangMessageValue(title, state.lang);
            setTitleValue(translatedTitleValue);
        }
        var translatedTextValue = LangHelper.getLangMessageValue(text, state.lang);
        setTextValue(translatedTextValue);
    }, [state]);
    return (_jsx(InputRadioWrapper, { children: _jsxs(InputRadioLabel, { children: [_jsx("input", { type: "radio", name: name, value: value, onChange: onChange, checked: checked }), _jsx("span", {}), _jsxs(InputRadioTitle, { children: [_jsx("p", { children: titleValue }), _jsx(InputRadioText, { children: textValue })] })] }) }));
}
